"use strict";

class UnitAssetsController {

    constructor(SSHttpService, SSUtilService, SSConfigService, SSAlertService, OTPService, SSConfirmationService, SSAwsService, SSUserService) {
        const self = this;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSConfigService = SSConfigService;
        self.SSAlertService = SSAlertService;
        self.OTPService = OTPService;
        self.SSConfirmationService = SSConfirmationService;
        self.SSAwsService = SSAwsService;
        self.SSUserService = SSUserService;

        self.data = SHOWSUITE.data;

        self.TYPE_FLOOR_PLAN_IMAGE = SHOWSUITE.TYPE_FLOOR_PLAN_IMAGE;
        self.TYPE_FLOOR_PLAN_2_IMAGE = SHOWSUITE.TYPE_FLOOR_PLAN_2_IMAGE;
        self.TYPE_KEY_IMAGE = SHOWSUITE.TYPE_KEY_IMAGE;
        self.TYPE_DIRECTION_IMAGE = SHOWSUITE.TYPE_DIRECTION_IMAGE;
        self.TYPE_DOCUMENT = SHOWSUITE.TYPE_DOCUMENT;
        self.TYPE_360_IMAGE = SHOWSUITE.TYPE_360_IMAGE;
        self.TYPE_ANNEX_A_IMAGE = SHOWSUITE.TYPE_ANNEX_A_IMAGE;
        self.TYPE_ANNEX_D_ANNEXURE_3_IMAGE = SHOWSUITE.TYPE_ANNEX_D_ANNEXURE_3_IMAGE;
        self.FLOORPLAN_ASSET_TYPE_BALCONY_SCREEN_ANNEX1 = SHOWSUITE.FLOORPLAN_ASSET_TYPE_BALCONY_SCREEN_ANNEX1;
        self.UNIT_ASSET_TYPE_CONSTRUCTION_PROGRESS_IMAGES = SHOWSUITE.UNIT_ASSET_TYPE_CONSTRUCTION_PROGRESS_IMAGES;
        self.UNIT_ASSET_TYPE_CONSTRUCTION_PROGRESS_DOCUMENTS = SHOWSUITE.UNIT_ASSET_TYPE_CONSTRUCTION_PROGRESS_DOCUMENTS;
        self.UNIT_ASSET_TYPE_FURNISHING_PACKAGES = SHOWSUITE.UNIT_ASSET_TYPE_FURNISHING_PACKAGES;

        self.TYPE_SHARE_ASSET = "Shared Assets";

        self.assetTypes = {};
        self.assetTypes[self.TYPE_FLOOR_PLAN_IMAGE] = 'Marketing Floor Plan Images';
        self.assetTypes[self.TYPE_ANNEX_A_IMAGE] = 'Annex A Images';
        self.assetTypes[self.TYPE_FLOOR_PLAN_2_IMAGE] = 'Annex B3 Images';
        self.assetTypes[self.TYPE_ANNEX_D_ANNEXURE_3_IMAGE] = 'Annex D Annexure 3 Image';
        self.assetTypes[self.FLOORPLAN_ASSET_TYPE_BALCONY_SCREEN_ANNEX1] = 'Balcony Screen Annex1 Image';
        self.assetTypes[self.TYPE_KEY_IMAGE] = 'Unit Images';
        self.assetTypes[self.TYPE_DIRECTION_IMAGE] = 'Key Plan Images';
        self.assetTypes[self.TYPE_DOCUMENT] = 'Documents';
        self.assetTypes[self.TYPE_360_IMAGE] = '360 Images';
        self.assetTypes[self.TYPE_SHARE_ASSET] = 'Social Sharing Images (File Size Max. 300KB)';
        self.assetTypes[self.FLOORPLAN_ASSET_TYPE_3D_FLOOR_PLAN] = '3D Floor Plan';
        self.assetTypes[self.UNIT_ASSET_TYPE_CONSTRUCTION_PROGRESS_IMAGES] = 'Construction Status Update(s) & Image(s)';
        self.assetTypes[self.UNIT_ASSET_TYPE_CONSTRUCTION_PROGRESS_DOCUMENTS] = "Construction Status Document(s)";
        self.assetTypes[self.UNIT_ASSET_TYPE_FURNISHING_PACKAGES] = 'Furnishing Packages';

        self.FLOORPLAN_ASSET_TYPE_3D_FLOOR_PLAN = SHOWSUITE.FLOORPLAN_ASSET_TYPE_3D_FLOOR_PLAN;
        self.FLOORPLAN_ASSET_TYPE_SHARE_360_IMAGE = SHOWSUITE.FLOORPLAN_ASSET_TYPE_SHARE_360_IMAGE;
        self.FLOORPLAN_ASSET_TYPE_SHARE_3D_FLOOR_PLAN = SHOWSUITE.FLOORPLAN_ASSET_TYPE_SHARE_3D_FLOOR_PLAN;
        self.FLOORPLAN_ASSET_TYPE_SHARE_FLOOR_PLAN = SHOWSUITE.FLOORPLAN_ASSET_TYPE_SHARE_FLOOR_PLAN;

        self.UNIT_ASSET_STATUS_IN_PROGRESS = SHOWSUITE.UNIT_ASSET_STATUS_IN_PROGRESS;
        self.UNIT_ASSET_STATUS_COMPLETED = SHOWSUITE.UNIT_ASSET_STATUS_COMPLETED;

        self.ASSET_STATUS = [
            {id : null, name: "NIL"},
            {id : self.UNIT_ASSET_STATUS_IN_PROGRESS, name:"In Progress"},
            {id: self.UNIT_ASSET_STATUS_COMPLETED, name:"Completed" },
        ];

        self.shareAssetTypes = {};
        self.shareAssetTypes[self.FLOORPLAN_ASSET_TYPE_SHARE_FLOOR_PLAN] = 'Floor Plan';
        self.shareAssetTypes[self.FLOORPLAN_ASSET_TYPE_SHARE_360_IMAGE] = '360 Images';
        self.shareAssetTypes[self.FLOORPLAN_ASSET_TYPE_SHARE_3D_FLOOR_PLAN] = '3D Floor Plan';
        
        self.ASSET_TYPE = {
            LOGO_IMAGE: 1,
            HERO_IMAGE: 2,
            KEY_IMAGE: 3,
            FACILITY_MAGE: 4,
            SITE_PLAN_A_IMAGE: 5,
            SITE_PLAN_B_IMAGE: 6,
            AD_VIDEO: 7,
            LAYOUT_VIDEO: 8,
            BROCHURE_PDF: 9,
            FLOOR_PLAN_PDF: 10,
            LIFE_STYLE_IMAGE: 11,
            MAP_IMAGE: 16,
            STATUS_UPDATE: self.UNIT_ASSET_TYPE_CONSTRUCTION_PROGRESS_IMAGES,
            FURNISHING_PACKAGES: self.UNIT_ASSET_TYPE_FURNISHING_PACKAGES,
        };

        if (self.SSUserService.isDeveloper()) {
            self.init();
        }
    }

    init() {
        const self = this;

        self.data = SHOWSUITE.data;

        self.property = SHOWSUITE.data.property;
        self.stack = SHOWSUITE.data.stack;
        self.unit = SHOWSUITE.data.unit;
        self.getUnitAssets();
    }

    getUnitAssets() {
        const self = this;

        if (!self.data.property_id || !self.data.unit_id) {
            return;
        }

        self.unitParams = {};

        let url = 'sec/developer/properties/' + self.data.property_id + '/units/' + self.data.unit_id + '/assets';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.assetFiles = {};

            self.unit_assets = response.data.unitAssets;
            self.unit_360_assets = self.unit_assets.filter(x => x.type == self.TYPE_360_IMAGE);
            self.unit_furnishing_packages = self.unit_assets.filter(x => x.type == self.UNIT_ASSET_TYPE_FURNISHING_PACKAGES);
            if (self.unit_assets) {
                _.forEach(self.unit_assets, function (asset) {
                    if (!_.has(self.assetFiles, asset.type))
                        self.assetFiles[asset.type] = [];

                    self.assetFiles[asset.type].push(asset);
                });
            }

            if (!self.unitParams) {
                self.unitParams = {};
            }
            self.unitParams.floor_plan_3d = self.unit.floor_plan_3d;
        });
    }

    // Assets
    uploadAssets(files, type, share = false, redirectUrl = null) {
        const self = this;

        if (share) {
            let share_fail = false;
            $.each(files, function(index, file) {
                if (file.size / 1024 > 300) {
                    share_fail = true;
                }
            });

            if (share_fail) {
                self.SSAlertService.danger("Error!", "Only maximum 300KB image is allowed.");
                return;
            }

        }

        let policyUrl = 'sec/developer/import/properties/s3-policy-document';

        jQuery.each(files, function (i, file) {

            loading(true);
            self.SSAwsService.uploadAPIRequest(file, policyUrl, function (response) {
                loading(false);

                // Add the asset to the property_assets
                self.addAsset(type, response.config.data.file.name, response.config.data.key, redirectUrl);
            });
        });
    }

    addAsset(type, name, fileUri, redirectUri = null) {
        const self = this;

        if (!(type && name && (fileUri || redirectUri))) return;

        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function (data) {

            let url = 'sec/developer/properties/' + self.property.id + '/units/' + self.unit.id + '/add-asset';
            let params = {
                type: type,
                name: name,
                file_uri: fileUri,
                redirect_url: redirectUri
            };

            loading(true);
            self.SSHttpService.postAPIRequest(url, params).then(function (response) {
                loading(false);

                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }

                if (!self.unit_assets) {
                    self.unit_assets = [];
                }
                self.unit_assets.push(response.data.asset);

                if (type == self.TYPE_360_IMAGE) {
                    if (!self.unit_360_assets) {
                        self.unit_360_assets = [];
                    }
                    self.unit_360_assets.push(response.data.asset);
                }

                if (type == self.UNIT_ASSET_TYPE_FURNISHING_PACKAGES) {
                    if (!self.unit_furnishing_packages) {
                        self.unit_furnishing_packages = [];
                    }
                    self.unit_furnishing_packages.push(response.data.asset);
                }

                if (!_.has(self.assetFiles, type)) {
                        self.assetFiles[type] = [];
                    }

                self.assetFiles[type].push(response.data.asset);
            });
        });
    }

    removeAsset(asset, type, idx) {
        const self = this;

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to remove this asset?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {

                self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function (data) {

                    let policyUrl = 'sec/developer/import/properties/s3-policy-document';
                    let apiUrl = 'sec/developer/properties/' + self.property.id + '/units/' + self.unit.id + '/assets/' + asset.id + '/delete';

                    loading(true);
                    self.SSAwsService.policyAPIRequest(policyUrl, function (policy) {
                        loading(false);

                        self.SSHttpService.getAPIRequest(apiUrl).then(function (responseObj) {
                            if (responseObj instanceof Error) {
                                self.SSAlertService.parseAndDisplayError(response);
                                return;
                            }

                            jQuery.each(self.unit_assets, function (i, _asset) {
                                if (_asset.id == asset.id) {
                                    self.unit_assets.splice(i, 1);
                                    return false;
                                }
                            });

                            if (type == self.TYPE_360_IMAGE) {
                                self.unit_360_assets = self.unit_360_assets.filter(x => x.id != asset.id);
                            }
                            if (type == self.UNIT_ASSET_TYPE_FURNISHING_PACKAGES) {
                                self.unit_furnishing_packages = self.unit_furnishing_packages.filter(x => x.id != asset.id);
                            }

                            self.assetFiles[type] = [];
                        });
                    });                        
                });
            }
        );
    }
    // Assets

    // 3D Model
    editFloorplan3D(status) {
        const self = this;

        self.floorplan3DEditMode = status;

        if (!self.unitParams) {
            self.unitParams = {};
        }
        self.unitParams.floor_plan_3d = self.unit.floor_plan_3d;
    }

    updateFloorplan3D() {
        const self = this;

        // Validate
        if (!self.unitParams.floor_plan_3d) {
            self.unitErrors.floor_plan_3d = 'Invalid URL';
            return;
        }
        self.unitParams.floor_plan_3d = self.unitParams.floor_plan_3d.trim();

        // Is Changed
        if (self.unitParams.floor_plan_3d == self.unit.floor_plan_3d) {
            self.editFloorplan3D(false);
            return;
        }

        self._updateFloorplan3D(self.unitParams.floor_plan_3d);
    }

    _updateFloorplan3D(floor_plan_3d) {
        const self = this;

        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function (data) {

            let url = 'sec/developer/properties/' + self.property.id + '/units/' + self.unit.id + '/update-floorplan3d';
            let params = {
                floor_plan_3d: floor_plan_3d
            };
            self.unitErrors = {};

            loading(true);
            self.SSHttpService.putAPIRequest(url, params).then(function (response) {
                loading(false);

                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    self.unitErrors = self.SSHttpService.parseErrors(response);
                    return;
                }

                self.SSAlertService.success('Success!', 'Floor Plan 3d URL updated successfully.');

                self.unit.floor_plan_3d = params.floor_plan_3d;
                self.editFloorplan3D(false);
            });
        });
    }

    goBack(){

        if(history.length)
            history.back();
        else
            window.location = "/developer/properties//"+ self.data.property_id +"/units";
    }

    removeFloorplan3D() {
        const self = this;

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to remove Floor Plan 3D?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function (selectedOption) {
                self._updateFloorplan3D();
            }
        );
    }
    // Pdf check
    isPdf(filename){
        const self = this;
        return self.SSUtilService.getFileExtension(filename)=='pdf';
    }

    splitPropertyAssets() {
        const self = this;

        self.assets = {
            hero: [],
            video: [],
            siteplan: [],
            facilities: [],
            brochurePdfs: [],
            floorPlanPdfs: [],
            map: []
        };

        _.each(self.property.property_assets, function (asset) {
            if (asset.type == self.ASSET_TYPE.HERO_IMAGE || asset.type == self.ASSET_TYPE.KEY_IMAGE) {
                self.assets.hero.push(asset);
            } else if (asset.type == self.ASSET_TYPE.AD_VIDEO || asset.type == self.ASSET_TYPE.LAYOUT_VIDEO) {
                self.assets.video.push(asset);
            } else if (asset.type == self.ASSET_TYPE.SITE_PLAN_A_IMAGE || asset.type == self.ASSET_TYPE.SITE_PLAN_B_IMAGE) {
                self.assets.siteplan.push(asset);
            } else if (asset.type == self.ASSET_TYPE.FACILITY_MAGE) {
                self.assets.facilities.push(asset);
            } else if (asset.type == self.ASSET_TYPE.BROCHURE_PDF) {
                self.assets.brochurePdfs.push(asset);
            } else if (asset.type == self.ASSET_TYPE.FLOOR_PLAN_PDF) {
                self.assets.floorPlanPdfs.push(asset);
            } else if (asset.type == self.ASSET_TYPE.MAP_IMAGE) {
                self.assets.map.push(asset);
            }
        });

        if (self.assets.video && self.assets.video.length > 0) {
            self.viewMedia = "video";
        } else {
            self.viewMedia = "hero";
        }
    }
    toggleDownloadsModal(status) {
        const self = this;

        self.downloadsModal = status;
        $('#downloadsModal').modal(status ? 'show' : 'hide');
    }

    updateConstructionStatus(asset){
        const self = this;

        if(!asset ) return;
        self.SSConfirmationService.getConfirmed( "Confirm!",
            "Are you sure you want to update construction status?",
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
            self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function (data) {

            let url = "sec/developer/properties/" + self.data.property_id + "/units/" + self.data.unit_id + "/assets/" + asset.id + "/status-update";

            let param  = { status : asset.status, };
            loading(true);
                self.SSHttpService.putAPIRequest(url, param).then(function (response) {
                    loading(false);
                    if (response instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(response);
                        self.unitErrors = self.SSHttpService.parseErrors(response);
                        return;
                    }
                self.SSAlertService.success('Success!', 'Construction Status updated successfully.');

                });
            });
        });
    }
}

UnitAssetsController.$inject = ['SSHttpService', 'SSUtilService', 'SSConfigService', 'SSAlertService', 'OTPService', 'SSConfirmationService', 'SSAwsService', 'SSUserService'];
app.controller('UnitAssetsController', UnitAssetsController);